import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Utils from '../utils/utils'
Vue.use(VueI18n)

/**
 * 获取当前语言
 * @return {String}
 * @api
 */
function getLocale () {
  const lang = Utils.getQueryString('lang') || 'zh-HK'
  return Utils.getLang(lang)
}

/**
 * 初始化多语言
 * @param {Object} langConfig
 * @return {Object}
 * @api
 */
function i18nSetting (langConfig) {
  return new VueI18n({
    locale: getLocale(),
    messages: langConfig
  })
}

export default i18nSetting
